<template>
  <div
    class="bottom-bar-close"
    @click="handleBottomStatus"
  >
    <svg-icon
      icon-class="icon-close"
    />
  </div>
</template>

<script>
import toast from 'fe-vui/toast'
import { useMatchDetailStore } from 'wap/stores/matchDetail'

export default {
  name: 'BottomBarClose',

  data() {
    return {
      broadcastList: [
        {
          text: 'Sorry, due to some reasons, the live commentary is temporarily suspended, please be patient.'
        }
      ]
    }
  },
  methods: {
    handleBottomStatus() {
      localStorage.setItem('live_commentary_bottom', false)
      useMatchDetailStore().updateCommentaryBotStatus(false)
      toast('Dynamic bottom bar closed successfully.')
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.bottom-bar-close {
  position: absolute;
  z-index: 2;
  top: -8/@rem;
  right: -8/@rem;
  display: none;
  width: 16/@rem;
  height: 16/@rem;
  align-items: center;
  justify-content: center;
  border-radius: 16/@rem;
  background-color: @normal;

  .svg-icon {
    color: @white;
    font-size: 12/@rem;
  }
}

.scale-bottom-right {
  animation: to_little 0.5s ease-in-out;
}

@keyframes to_little {
  0% {
    transform: translate(0, 0) scale(1);
  }

  90% {
    transform: translate(50%, 50%) scale(0.1);
  }

  100% {
    transform: translate(50%, 50%) scale(0);
  }
}
</style>
